import { Vue, Component } from 'vue-property-decorator'
import { mapState } from 'vuex'
import Container from 'typedi'
import ErrorHandlerService from '@/modules/common/services/error-handler.service'

@Component({
  name: 'GtrEventBookmarks',
  computed: {
    ...mapState('event', ['eventBookmarks'])
  }
})

export default class GtrEventBookmarks extends Vue {
  eventBookmarks!: Array<Record<string, any>>

  data () {
    return {
      bookmarkHovered: false,
      closeBookmarkMenuOnClick: true,
      editBookmarkModal: false,
      addBookmarkModal: false,
      deleteBookmarkModal: false,
      editBookmarkUuid: null,
      deleteBookmarkUuid: null,
      addBookmarkData: {
        name: null,
        url: null
      },
      editBookmarkData: {
        name: null,
        url: null
      }
    }
  }

  get activeBookmarks () {
    return ((this as any).eventBookmarks || []).filter((bookmark: any) => bookmark.active === 1)
  }

  mounted () {
    this.fetchBookmarks()
  }

  private fetchBookmarks () {
    try {
      this.$store.dispatch('event/fetchBookmarks', this.$route.params.event_uuid).catch(error => Container.get(ErrorHandlerService).error(error))
    } catch (error) {
      Container.get(ErrorHandlerService).error(error)
    }
  }

  private handleAddBookmarkOpen () {
    this.$data.addBookmarkModal = true
    this.$data.closeBookmarkMenuOnClick = false
    this.$data.addBookmarkData.url = window.location.href
  }

  private handleAddBookmarkClose () {
    this.$data.addBookmarkModal = false
    this.$data.closeBookmarkMenuOnClick = true
    this.$data.addBookmarkData.name = null
    this.$data.addBookmarkData.url = null
  }

  private async addBookmark () {
    try {
      await this.$store.dispatch('event/addBookmark', {
        event_uuid: this.$route.params.event_uuid,
        data: {
          ...this.$data.addBookmarkData
        }
      })
      this.handleAddBookmarkClose()
    } catch (err) {
      Container.get(ErrorHandlerService).error(err)
    }
  }

  private handleEditBookmarkOpen (uuid: string) {
    this.$data.editBookmarkUuid = uuid
    const bookmark = this.activeBookmarks.filter((bookmark: any) => bookmark.uuid === uuid).pop()
    this.$data.editBookmarkModal = true
    this.$data.closeBookmarkMenuOnClick = false
    this.$data.editBookmarkData.name = bookmark.name
    this.$data.editBookmarkData.url = bookmark.url
  }

  private handleEditBookmarkClose () {
    this.$data.editBookmarkUuid = null
    this.$data.editBookmarkModal = false
    this.$data.closeBookmarkMenuOnClick = true
    this.$data.editBookmarkData.name = null
    this.$data.editBookmarkData.url = null
  }

  private async editBookmark () {
    try {
      await this.$store.dispatch('event/updateBookmark', {
        event_uuid: this.$route.params.event_uuid,
        bookmark_uuid: this.$data.editBookmarkUuid,
        data: {
          ...this.$data.editBookmarkData
        }
      })
      this.handleEditBookmarkClose()
    } catch (err) {
      Container.get(ErrorHandlerService).error(err)
    }
  }

  private handleDeleteBookmarkOpen (uuid: any) {
    this.$data.deleteBookmarkUuid = uuid
    this.$data.deleteBookmarkModal = true
    this.$data.closeBookmarkMenuOnClick = false
  }

  private handleDeleteBookmarkClose () {
    this.$data.deleteBookmarkUuid = null
    this.$data.deleteBookmarkModal = false
    this.$data.closeBookmarkMenuOnClick = true
  }

  private async deleteBookmark () {
    try {
      await this.$store.dispatch('event/updateBookmark', {
        event_uuid: this.$route.params.event_uuid,
        bookmark_uuid: this.$data.deleteBookmarkUuid,
        data: {
          active: 0
        }
      })
      this.handleDeleteBookmarkClose()
    } catch (err) {
      Container.get(ErrorHandlerService).error(err)
    }
  }
}
